export const PAGE_ROUTES = {
  APPLICATION: '/',
  CREATE_ACCOUNT: '/registration',
  RENTER_SIGN_UP_1: '/registration/r1',
  RENTER_SIGN_UP_2: '/registration/r2',
  RENTER_SIGN_UP_3: '/registration/r3',
  OWNER_SIGN_UP_1: '/registration/o1',
  OWNER_SIGN_UP_2: '/registration/o2',
  OWNER_SIGN_UP_3: '/registration/o3',
  VERIFY_OTP: '/registration/verifyOtp',
  ADD_PHONE_NUMBER: '/registration/addPhoneNumber',
  ADD_EMAIL: '/registration/addEmail',
  DASHBOARD: '/dashboard',
  LOGIN: "/login",
  LOGOUT: "/logout",
  RESET_PASSWORD: "/resetpassword",
  PROFILE: "/profile",
  LISTING: "/listing",
  SEARCH: "/search",
  FEATURED_LISTING: "/featuredlistings",
  ADMIN: "/admin",
  VERIFY_EMAIL: "/verifyemail",
  BLOGS_AND_RESOURCES: "/resources",
  COMPLETE_PROFILE: "/registration/completeProfile",
  TERMS_CONDITIONS: "/terms-conditions",
  PRIVACY_POLICY: "/privacy-policy",
  CREATE_LISTING: "/dashboard/listing/forms/details",
  CREATE_LISTING_APP_URL: "/app/#/dashboard/listing/forms/details"
}
